export const achievementData = {
    bio : "Putting quantified achievements on a resume is great, but I just don’t work with hard numbers. I have no data to support the quality of my work. If you have lots of relevant experience, the heading statement of your resume will be a summary.",
    achievements : [
        {
            id : 1,
            title : 'KSUM Idea grant winner',
            details : 'Our team Emerald Received an Idea grant of 2 lakhs for our project Rainbow.',
            date : 'March 15, 2022',
            field : 'Web development',
            image : ' https://drive.google.com/file/d/1ixCyY2EX4AEnvipjhotGdDZmMqyVaRsU/view'
        },
        {
            id : 2,
            title : 'Young Innovators Program K-DISC',
            details : 'Got selected for the business scope and uniqueness of emerald and received a grant of rupees 30,000 issued by Kerala Govt. through K-DISC.',
            date : 'June 20, 2022',
            field : 'Web development',
            image : ''
        },
        {
            id : 3,
            title : 'Foundations, Data data everywhere',
            details : 'Professional Data Engineers enable data-driven decision making by collecting, transforming, and publishing data.',
            date : 'Jan 18, 2022',
            field : 'Data Analytics',
            image : 'https://www.coursera.org/account/accomplishments/certificate/5GRHMYQPUDX8'
        }

    ]
}


// Do not remove any fields.
// Leave it blank instead as shown below.

/*

export const achievementData = {
    bio : "",
    achievements : []
}

*/